export default function Example() {
    return (
      <div className="bg-white py-6 sm:py-12">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="text-center text-lg/8 font-semibold text-gray-900">
            Ils nous soutiennent
          </h2>
          <div className="mx-auto mt-10 grid max-w-lg grid-cols-1 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-3 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            <img
              alt="Paris&Co"
              src="https://datasulting-storage.up.railway.app/omde/Paris&Co-logo-CMJN_bleu-fond-blanc%20small.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
            <img
              alt="BPI Paris"
              src="https://upload.wikimedia.org/wikipedia/fr/thumb/a/ad/Logo_Bpifrance.svg/2560px-Logo_Bpifrance.svg.png"
              width={158}
              height={48}
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
            />
            <img
              alt="French Tech"
              src="https://www.creads.com/wp-content/uploads/2021/05/ft_logo-05.png"
              width={158}
              height={48}
              className="col-span-2 max-h-16 w-full object-contain lg:col-span-1"
            />
          </div>
        </div>
      </div>
    )
  }
  